export const PettyCashCode = [
  { PettyCashCodes: "PC001" },
  { PettyCashCodes: "PC002" },
];
export const PettyCashCodessingle = [
  {label: "PC001",value:"PC001" },
  { label: "PC002" ,value:"PC002"},
];
export const TransactionCode = [
  { label: "Trans0123", value: "Trans0123" },
  { label: "Trans0124", value: "Trans0123" },
];
export const Criteria = [
  { label: "Request", value: "Request" },
  { label: "Direct", value: "Direct" }
];
export const VATMainAccount = [
  { label: "MACC001", value: "MACC001" },
  { label: "MACC002", value: "MACC002" },
  { label: "MACC003", value: "MACC003" },
];
export const VATSubAccount = [
  { label: "MSACC001", value: "MSACC001" },
  { label: "MSACC002", value: "MSACC002" },
  { label: "MSACC003", value: "MSACC003" },
];
export const WHTMainAccount = [
  { label: "MACC001", value: "MACC001" },
  { label: "MACC002", value: "MACC002" },
  { label: "MACC003", value: "MACC003" },
];
export const WHTSubAccount = [
  { label: "MSACC001", value: "MSACC001" },
  { label: "MSACC002", value: "MSACC002" },
  { label: "MSACC003", value: "MSACC003" },
];



export const BankAccountCode = [
  { BankAccountCode: "Bk001" },
  { BankAccountCode: "Bk002" },
  { BankAccountCode: "Bk003" },
];

export const SubAccount = [
  { SubAccount: "SAC001" },
  { SubAccount: "SAC002" },
  { SubAccount: "SAC003" },
];
export const CurrencyType = [
  { CurrencyType: "PHP" },
  // { CurrencyType: "US" },
  { CurrencyType: "USD" },
  { CurrencyType: "AD" },
];
export const Transcode = [
  { Transcode: "PRM" },
  { Transcode: "COMM" },
  { Transcode: "REMT" },
];
export const Branchcode = [
  { Branchcode: "PHP001" },
  { Branchcode: "PHP002" },
  { Branchcode: "PHP003" },
  { Branchcode: "PHP004" },
];

export const Departcode = [
  { Departcode: "FIN" },
  { Departcode: "MKT" },
  { Departcode: "IT" },
  { Departcode: "SLS" },
];
export const Name = [
  { label: "Leo", Name: "Leo" },
  { label: "Yuva", Name: "Yuva" },
  { label: "Sindhu", Name: "Sindhu" },
  { label: "Ayisha", Name: "Ayisha" },
  { label: "Pandi", Name: "Pandi" },
];
export const Maincode = [
  { Maincode: "MAC001" },
  { Maincode: "MAC002" },
  { Maincode: "MAC003" },
];
export const Pettycashdescription = [
  { Pettycashdescription: "PCD192992" },
  { Pettycashdescription: "PCD199191" },
  { Pettycashdescription: "PCD101019" },
  { Pettycashdescription: "PCD181929" },
];
